import styled from 'styled-components'
import colors from '@settings/styleSettings'

export const PasswordNeedsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const PasswordNeedsLabel = styled.div`
  color: ${colors.strongGray};
  font-size: 16;
`

export const PasswordNeedsPopup = styled.div`
  color: ${colors.primary};
  font-size: 16;
  font-family: Circular-Std-Medium;
`

export const PasswordNeedsBackground = styled.div`
  display: inherit;
  background-color: ${colors.background};
  border-radius: 24px;
  padding: 4px 8px;
`
